var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Пресеты")]),_c('u-block',[_c('u-table',{attrs:{"data":_vm.list,"fields":_vm.fields},scopedSlots:_vm._u([{key:"column_name",fn:function(ref){
var row = ref.row;
return [_c('router-link',{staticClass:"link",attrs:{"to":{ name: 'presetItem', params: { id: row.id } }}},[_vm._v(" "+_vm._s(row.name)+" ")])]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }